import React from 'react';
import {connect} from 'react-redux';
import CustomerSelector from '/app/src/model/Customer/selector';
import ConversationSelector from '/app/src/model/Conversation/selector';

import {Flex} from '/app/src/component';

import TicketPreview from '/app/src/component/Ticket/Preview'
import {Spinner} from '/app/src/component'

class PreviousTickets extends React.Component {
    constructor(props) {
        super(props);
        this.__renderItems = this.__renderItems.bind(this);
    }

    __renderItems(tickets) {
        let lst = []
        tickets.forEach((ticket) => {
            if(!ticket.info) return null;
            const key = ticket.info.payload.company_ticket_id;
            lst.push((
                <Flex w='100%' shrink={0} key={key} onClick={() => this.props.toSingleView(ticket.info.payload.room)}
                borderRadius='60px'
                backgroundHover='darkwhite'>
                    <TicketPreview ticket={ticket} />
                </Flex >
            ))
        })
        return lst;
    }
    render() {
        let customer = this.props.customer
        let tickets = this.props.tickets
        let fetched = this.props.fetched
        let fetching = this.props.fetching

        if(!customer)
            return <Flex grow column center>
                <p> Ingen kund</p>
            </Flex>


        if(!fetched && fetching){
            return(
             <Flex column center height='70%' w='100%'>
                <Spinner text='Hämtar senaste ärenden'/>
            </Flex>
            )
        }
        if(!tickets.length){
            return (
                <Flex center h='100%' w='100%' color='grey'>
                    <h3>Inga tidigare ärende.</h3>
                </Flex>
            )
        }

        return(
            <Flex width='100%' center >
                <Flex column overflowY='auto' w='100%' h='100%'>
                {this.__renderItems(tickets)}
                </Flex>
            </Flex>
        );
    }

}

function mapStateToProps(state, props){
  const customer = props.customer
  const customerId = CustomerSelector.getId(customer)
  const rooms = CustomerSelector.getTickets(customer).toJS()['payload']
  let tickets = []
  for(var room in rooms){
      tickets.push(ConversationSelector.getByRoom(state, rooms[room]).toJS())
  }

  return {
      customerId: customerId,
      fetching: tickets.fetching,
      fetched: tickets.fetched,
      tickets: tickets
  }

}

export default connect(mapStateToProps)(PreviousTickets);



// WEBPACK FOOTER //
// ./src/container/Customer/PreviousTickets.js